import { Component, OnInit } from '@angular/core';
import { AppGlobalsService } from '../services/app-globals.service';

@Component({
  selector: 'app-attribution',
  templateUrl: './attribution.component.html',
  styleUrls: ['./attribution.component.css'],
  standalone: false
})
export class AttributionComponent implements OnInit {
  public darkMode = false;
  constructor(private appGlobals: AppGlobalsService) { }

  ngOnInit(): void {
   this.darkMode = this.appGlobals.getStoredDarkModeSetting();
  }

}
